import PropTypes from "prop-types";
import { initializeApollo } from "lib/apolloClient";
import PageLayout from "components/shared/pageLayout/PageLayout";
import Privacy from "components/privacy/Privacy";

import { GetPDF } from "../helpers/api/cadeauConcepten/queries/document.gql";

function PrivacyPage({ fileUrl }) {
    return (
        <PageLayout
            slug="cookie-privacy"
            title="Privacy | Lees! Cadeau"
            description="Bekijk hier de Cookie & Privacy Policy van Lees! Cadeau."
        >
            <Privacy fileUrl={fileUrl} />
        </PageLayout>
    );
}

PrivacyPage.propTypes = {
    fileUrl: PropTypes.string
};

PrivacyPage.defaultProps = {
    fileUrl: undefined
};

export async function getStaticProps() {
    if (!process.env.featureFlags.ssr) {
        return { props: {} };
    }
    const apolloClient = initializeApollo();
    let data;

    try {
        data = await apolloClient.query({
            query: GetPDF,
            variables: {
                kind: "PRIVACY"
            },
            errorPolicy: "ignored",
            context: {
                timeout: 10000
            }
        });
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(error.message);
    }

    return {
        props: { fileUrl: data?.data?.document?.url || null },
        revalidate: 86400
    };
}

export default PrivacyPage;
